import React from 'react';
import * as Inovx from '@shared';
import RoleActions from '../actions/RoleActions';
import RoleStore from '../stores/RoleStore';
import RoleConstants from '../constants/RoleConstants';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var InovxControls = Inovx.Shared.Controls;

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;

declare var InovxLoader: any;

interface RoleFormProps {
}

interface RoleFormState {
    isAdding?: boolean;
    isEditing?: boolean;

    allRoles?: IOrganizationRole[];
    role?: IOrganizationRole | any;

    isActionInProgress?: boolean;
    actionInProgressMsg?: string;

    validation?: IValidationDictionaryObject;
}

function getIsActionInProgress(): boolean {
    return SystemStore.isActionInProgress(RoleConstants.ROLE_ADD) ||
        SystemStore.isActionInProgress(RoleConstants.ROLE_EDIT);
}

var _actionInProgressMsg: string;

function getRoleFormState(): RoleFormState {
    return {
        isAdding: RoleStore.getIsAdding(),
        isEditing: RoleStore.getIsEditing(),

        allRoles: RoleStore.getAll(),
        role: RoleStore.getRole(),

        isActionInProgress: getIsActionInProgress(),
        actionInProgressMsg: _actionInProgressMsg,

        validation: RoleStore.getValidation(RoleConstants.ROLE_ADD_FORM)
    };
}

class RoleForm extends React.Component<RoleFormProps, RoleFormState> {
    constructor(props: RoleFormProps) {
        super(props);

        this.state = getRoleFormState();
        _actionInProgressMsg = InovxLoader.t("role:form.saving");
    }

    private _validateUser = () => {
        var form: any = this.refs["assignUser"];
        if (form.isValid(this._isEmptyOrNull)) {
            return true;
        }
        return false;
    }

    private _roleHasUser = (userName: string, authorizedUsers: IUser[]) => {
        for (var index in authorizedUsers) {
            if (authorizedUsers[index].UserName == userName) {
                return true;
            }
        };
        return false;
    }

    private _assignUserToRole = (users: IUser[]) => {
        if (users.length > 0) {
            RoleActions.addUsers(users);
        }
    }

    private _deleteAuthorizedUser = (e: Event, user: IUser) => {
        RoleActions.deleteAuthorizedUser(user);
    }

    private _isEmptyOrNull = (value: string) => {
        return value && value.trim().length > 0
    }

    private _saveRole = () => {
        if (this.state.isAdding) {
            RoleActions.createRole();
        } else {
            RoleActions.editRole();
        }
    }

    private _cancel = () => {
        RoleActions.finishEdit();
    }

    private _loadState = () => {
        this.setState(getRoleFormState());
    }

    private _onChange = (event: any) => {
        RoleActions.editCurrentRole(RoleConstants.ROLE_ADD_FORM, event.target.name, event.target.value);
    }

    private _systemChange = () => {
        this.setState({ isActionInProgress: getIsActionInProgress() });
    }

    private _checkForUnsavedChanges = (event: any) => {
        if (RoleStore.getHasChanges()) {
            event.returnValue = InovxLoader.t("common:msgBox.browserSaveChanges");
        };
    }

    componentDidMount() {
        RoleStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    componentWillUnmount() {
        RoleStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);
    }

    render() {

        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        var role = this.state.role;

        var roleNameInput = {
            ...inputObj,
            name: 'Name',
            id: 'roleApp-name-input',
            value: role.Name
        };

        var roleDescriptionInput = {
            ...inputObj,
            name: 'Description',
            id: 'roleApp-desc-input',
            value: role.Description
        };

        var header = this.state.isAdding ? InovxLoader.t('role:header.newRole') : InovxLoader.t('role:header.editRole');

        var columns = [{
            field: "UserName",
            headerText: InovxLoader.t("role:form.userName"),
            width: "40%"
        }, {
            field: "Enabled",
            headerText: InovxLoader.t("role:form.userStatus"),
            values: [
                { value: true, text: InovxLoader.t("role:common.enabled") },
                { value: false, text: InovxLoader.t("role:common.disabled") }
            ]
        }];

        var userDataSource = this.state.role.Users;
        var userDefaultSort = [{
            field: "UserName",
            dir: "ascending"
        }];

        var userCommands = {
            headerText: InovxLoader.t("role:common.actions"),
            command: [{
                iconClassName: 'glyphicon glyphicon-trash',
                click: this._deleteAuthorizedUser
            }],
            width: "85px",
        }

        return (
            <InovxControls.StaticHeaderForm title={header} saveOnClick={this._saveRole} saveBtnId="roleApp-save-btn" cancelOnClick={this._cancel} cancelBtnId="roleApp-cancel-btn"
                isActionInProgress={this.state.isActionInProgress} inProgressMessage={this.state.actionInProgressMsg} >

                <InovxControls.FormField title={`${InovxLoader.t("role:common.roleName")}*`} inputName='Name'>
                    <InovxControls.ValidationInput {...roleNameInput} className="form-control" onChange={this._onChange} validation={this.state.validation['Name']} />
                </InovxControls.FormField>

                <InovxControls.FormField title={InovxLoader.t("role:common.description")} inputName='Description'>
                    <textarea {...roleDescriptionInput} onChange={this._onChange} />
                </InovxControls.FormField>

                <InovxControls.FormField title={InovxLoader.t("role:form.assignUsers")} inputName='AssignUsers' >
                    <InovxControls.MultiSelect minLength={1} displayProp={"UserName"} url={`${UrlUtilities.getApiUrl()}/RoleApi/api/user/SearchUsers`}
                        onClick={this._assignUserToRole} parameters={{ maxNumberOfResults: 5 }} numParameter='maxNumberOfResults' searchProperty={'searchString'} btnLabel={InovxLoader.t("role:form.add")} keyProp="UserID" />
                </InovxControls.FormField>

                <Inovx.Shared.Controls.Grid dataSource={userDataSource} commands={userCommands} columns={columns} defaultSort={userDefaultSort} sort={true} />
            </InovxControls.StaticHeaderForm>
        );
    }
}

export default RoleForm;
